export const FAILED = 'setting_business_type/failed';
export const LOADING = 'setting_business_type/loading';
export const SUCCESS = 'setting_business_type/success';
export const SET_DATA = 'setting_business_type/set_data';
export const RESET = 'setting_business_type/reset';
